import { Box, Image } from "@chakra-ui/react";
import React from "react";

export default function Loading() {
  return (
    <Box
      pos="fixed"
      w="100%"
      h="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      zIndex={999}
    >
      <Image h="50px" w="50px" src={require("../assets/img/spinner.gif")} />
    </Box>
  );
}
